import React, { Component, useEffect, useState } from 'react';
import { useDispatch, ReactReduxContext } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import { Tooltip, Input, Menu, Dropdown, Table, Button, Spin, message, Popconfirm } from 'antd';
import { DisconnectOutlined, EditOutlined, SyncOutlined, DownOutlined, PlusOutlined } from '@ant-design/icons';
import querystring from 'querystring';
import debounce from 'lodash/debounce';
import moment from 'moment';
import mapper from 'object-mapper';
import deepEqual from 'deep-equal';

import { vLoading, editOrders, editOrdersInfoM, fetchOrdersCollectionIfNeeded, fetchOrdersEdit, fetchSyncOrders } from './../../../Actions/Orders';
import { getStatus, readSearchCondition, isSearchConditionEmpty } from './../../../Libs/Orders';
import { unitIdToName } from './../../../Libs/Products';
import { truncate } from './../../../Libs/Decimal';
import SectionWrapper from './../../SectionWrapper';
import Supplier from './SupplierDropdown';
import TParagraph from './Paragraph';
import Numberic from './../../Common/Input/Numeric';
import { get, post, put, del } from '@/Libs/Request/index'
import BatchImportWrapper from './BatchImportWrapper';

const P = `//${document.domain}:8360`;

// function Test() {
//   const dispatch = useDispatch();
//   dispatch(vLoading(true));
//   return <div>test</div>
// }

const Advert = (props) => {
  const [active, setActive] = useState({ active: props.value });
  useEffect(() => {
    setActive(props.value)
  }, [props.value]);
  return (
    <Button className={props.className} type="link" onClick={() => {
      props.dispatch(!active);
      setActive({ active: !active });
    }} >
      <DisconnectOutlined type="link" style={active ? { color: '#f5222d' } : {}} />
    </Button>
  )
}

const AdvertCost = (props) => {
  const [value, setValue] = useState(0);
  useEffect(() => {
    setValue(props.value);
  }, [props.value]);
  if (String(props.checked) === '1') {
    return (
      <div>刷单佣金：<Numberic className='advert-cost' value={String(value || '0')} style={{ width: '60px' }} onChange={(e) => {
        const v = (e || '0').trim();
        setValue(v);
        props.dispatch(v);
      }} /></div>
    )
  }
  return '';
}

const Sync = (props) => {
  const [timer, setTimer] = useState(0);
  return (
    <Button className={`${props.className} sync-btn`} type="link" disabled={timer === 0 ? false : true}
      onClick={() => {
        setTimer(3);
        message.info('正在同步.');
        props.dispatch();
        setTimeout(() => {
          setTimer(0);
        }, 3000);
      }} >
      <SyncOutlined />
    </Button>
  );
}

class OptimizedRow extends React.Component {
  static contextType = ReactReduxContext;
  constructor() {
    super();
    this.uDebounce = debounce(this.uDebounce, 500);
    this.userId = localStorage.getItem('userId');
  }
  uDebounce = (value, cb) => {
    // console.log(value);
    cb(null, value);
  }
  shouldComponentUpdate(nextProps) {
    if (this.props.children[2] !== undefined) {
      const npRecord = this.props.children[2].props.record;
      const tpRecord = nextProps.children[2].props.record;
      if (!deepEqual(npRecord, tpRecord)) {
        if (tpRecord !== undefined) {
          this.context.store.dispatch(editOrders({ changed_by_id: this.userId }, tpRecord.o_id))
          this.uDebounce(tpRecord, (err, v) => {
            this.context.store.dispatch(fetchOrdersEdit(tpRecord));
          });
        }
        return true;
      } else {
        return false;
      }
    }
    return false;
  }
  render() {
    return (
      <tr {...this.props} />
    )
  }
}

export default class extends Component {
  static contextType = ReactReduxContext;
  constructor(props) {
    super(props);
    this.uDebounce = debounce(this.uDebounce, 1000);
    this.columns = [
      {
        title: '订单信息',
        dataIndex: 'order1',
        className: 'order-info',
        render: (text, record) => {
          let booking_date = record.orders_info.length === 0 ? '-' : record.orders_info[0].booking_date;
          booking_date = (booking_date || false) ? moment(booking_date).format('YYYY-MM-DD HH:mm:ss') : '-';
          let departure_date = ((record.orders_info[0].departure_date || false) ? moment(record.orders_info[0].departure_date).format('YYYY-MM-DD HH:mm:ss') : '-');
          const hasEmptyDepartureDate = record.orders_info.some(info => !info.departure_date);

          return (
            <div>
              <div>{record.web_source} {record?.web_shop?.code || ''} {record?.web_shop?.desc || ''}</div>
              <div>订单号：{record.ordersn}</div>
              <div>团号：{record.groups_no || '-'}</div>
              <div>销售：{(record.saler || { real_name: '-' }).real_name}</div>
              <div>预订日期：{booking_date}</div>
              <div><span style={{ color: hasEmptyDepartureDate ? 'red' : 'inherit' }}>出行日期：{departure_date}</span></div>
            </div>
          );
        }
      },
      {
        title: '预订人信息',
        dataIndex: 'order2',
        className: 'scheduled-info',
        render: (text, record, index) => {
          return (
            <div>
              <div>姓名：{record.name || '-'}</div>
              <div>UID：{record.account || '-'}</div>
              {/* <div>邮箱：{record.email || '-'}</div> */}
              <div>电话：{record.phone || '-'}</div>
              <div>微信号：{record.weixinid || '-'}</div>
            </div>
          );
        }
      },
      {
        title: '产品信息',
        dataIndex: 'order3',
        className: 'product-info',
        render: (text, record, index) => {
          if (record.orders_info.length === 0) {
            return <div></div>;
          }
          const pg = record.orders_info[0].package || [];
          let unitStr = '';
          if (pg.length > 0) {
            unitStr = ` (${unitIdToName(record.orders_info[0].unit_id)})`;
          }
          const destination = [].concat((record.orders_info[0].destination_paths_name || []), []).slice(-1);
          return (
            <div>
              <TParagraph lgMaxWitdh="200px" xlMaxWitdh="300px" text={<div style={{ color: ((record.orders_info[0].pp_id) != 0 ? 'inherit' : '#f81d22') }}>产品：{record.orders_info[0].product_name}</div>} />
              <TParagraph lgMaxWitdh="200px" xlMaxWitdh="300px" text={<div>库存：{record.orders_info[0].ptitle || '-'}</div>} />
              <div>供应商：{
                (() => {
                  const name = record.supplier_suffix_name || '';
                  return name === '' ? '' : `[${name}] `;
                })()
              }{(record.orders_info[0].supplier || { company: '-' }).company}</div>
              {/* <Supplier data={record.orders_info[0]} /> */}
              <div>数量：{record.orders_info.length === 0 ? 0 : record.orders_info[0].num} {unitStr}</div>
              <div>商品编码：{record.orders_info[0].sku_code}</div>
              <div>地区：{destination} </div>
            </div>
          );
        }
      },
      {
        title: '金额',
        dataIndex: 'order4',
        className: 'price-info',
        render: (text, record, index) => {
          let payment;
          if (record.orders_info.length === 0) {
            payment = '';
          } else {
            payment = record.orders_info[0].transaction_amount;
          }
          // const totalProfitMargin = (+(record.total_profit_margin * 100)).toFixed(0); ({totalProfitMargin}%)
          return (
            <div>
              <div>成交价：{truncate((record.total_transaction_amount || 0), 2)}</div>
              {/* <div>佣金率：{record.orders_info[0].commission_rate}</div> */}
              <div>利润：{truncate((record.total_profit || 0), 3)} {record.o_profit_margin || ''} </div>
              {/* <div>成本：{record.orders_info[0].settlement_price}</div> */}
              <AdvertCost checked={record.is_click_farm} value={record.farm_cost} dispatch={e => this.context.store.dispatch(editOrders({ 'farm_cost': e }, record.o_id))} />
            </div>
          );
        }
      },
      {
        title: '订单状态',
        dataIndex: 'order5',
        className: 'status-info',
        render: (text, record, index) => {
          if (record.orders_info.length === 0) {
            return;
          }
          const Shipment = (props) => {
            const dispatch = useDispatch();
            const [value, setValue] = useState('');
            const menu = (
              <Menu onClick={(e) => {
                // dispatch(editOrdersInfoM({ is_shipment: e.key }, props.id))
                const url = `/api/tool/orders/batch-shipment?o_id=${props.id}&is_shipment=${e.key}`
                get(url, {}, { cache: 'no-store', headers: { 'Content-Type': 'application/html' } })
                  .then(response => {
                    if (response.ok) {
                    }
                  });
                setValue(e.key);
              }}>
                <Menu.Item key="0">未出单</Menu.Item>
                <Menu.Item key="1">已出单</Menu.Item>
              </Menu>
            );
            return (
              <Dropdown key="2" overlay={menu}>
                <div>
                  {value === '' ? props.value : (['未出单', '已出单'])[value]} <DownOutlined />
                </div>
              </Dropdown>
            );
          }
          // console.log(index, getStatus(record.orders_info[0].status_code, record.pf_id)[0]);
          // console.log(record.orders_info[0].status_code, record.orders_info[0].status.status_title);
          const status_code = mapper.getKeyValue(record, 'orders_info[0].status_code');
          const status_title = mapper.getKeyValue(record, 'orders_info[0].status.status_title');
          return (
            <div>
              {/* <div>{(record.orders_info[0].is_shipment + '').toString() === '0' ? '未出单' : '已出单'}</div> */}
              <Shipment id={record.o_id} value={(record.orders_info[0].is_shipment + '').toString() === '0' ? '未出单' : '已出单'} />
              <Tooltip title={(status_code) ? status_title : getStatus(record.orders_info[0].status_code, record.pf_id, record.order_types)[0]}>
                <span>{
                  (status_code)
                    ? status_title
                    : getStatus(record.orders_info[0].status_code, record.pf_id, record.order_types)[1]
                }</span>
              </Tooltip>
            </div>
          );
        }
      },
      {
        title: '操作',
        className: 'action',
        render: (text, record, index) => {
          const style = { 'fontSize': '15px' };
          return (<span>
            {/* <Link to={'/orders/action/' + text.o_id} style={{ 'marginRight': '10px' }} target="_blank">编辑</Link> */}
            <Advert className='advert' value={Boolean(record.is_click_farm)} dispatch={e => this.context.store.dispatch(editOrders({ 'is_click_farm': Number(e) }, record.o_id))} />
            <Sync className='sync' dispatch={() => this.context.store.dispatch(fetchSyncOrders(record.ordersn, record.pf_id, { page: this.state.currentPage }))} />
            <Link className='edit' to={'/orders/action/' + text.o_id} target="_blank"><EditOutlined style={style} /></Link>
          </span>);
        },
      }
    ];
    this.state = {
      'currentPage': this.props.currentPage || 1,
    };
  }

  uDebounce = (value, cb) => {
    // console.log(value);
    cb(null, value);
  }

  handleTableChange(pagination, dispatch) {
    dispatch(vLoading(true));
    // this.context.router.history.push(`/orders/${pagination.current}`);
    // this.context.router.history.replace(`/orders/${pagination.current}`);
    this.setState({
      currentPage: pagination.current
    });
    dispatch(fetchOrdersCollectionIfNeeded({
      page: pagination.current
    }));
  }

  tableRender(data, loading, pagination) {
    // const self = this;
    return (
      <SectionWrapper id="orders-wrapper">
        <ReactReduxContext.Consumer>
          {({ store }) => (
            <Table
              columns={this.columns}
              dataSource={data}
              loading={loading}
              pagination={pagination}
              defaultExpandAllRows={true}
              rowKey={record => record.o_id}
              components={{ body: { row: OptimizedRow } }}
              // bordered
              // showHeader={false}
              onChange={(pagination) => this.handleTableChange(pagination, store.dispatch)}
            />
          )}
        </ReactReduxContext.Consumer>
      </SectionWrapper>
    );
  }

  render() {
    const { data, loading } = this.props.Orders.toJS();
    //console.log(1111, this.props.Orders.toJS());
    const pagination = {
      pageSize: 20,
      current: this.props.Orders.get('currentPage'),
      total: this.props.Orders.get('count'),
    }
    const dividersId = { 'dividers_id': localStorage.getItem('dividersIdCurrent') };
    let qs = querystring.parse(readSearchCondition());
    // const P = 'http://172.21.24.30:8360';
    return (
      <Spin spinning={loading} tip="Loading...">
        {
          this.props.showAction &&
          <div style={{ height: '32px', marginBottom: '24px' }}>
            <Popconfirm
              title="确定设置刷单?"
              onConfirm={() => {
                const str = querystring.stringify(qs);
                if (isSearchConditionEmpty(qs, dividersId)) {
                  alert('请筛选条件');
                  return false;
                }
                window.open(`${P}/api/tool/orders/batch-click-farm?${str}`)
              }}
              okText="是"
              cancelText="取消"
            >
              <Button style={{ float: 'left', marginRight: '5px' }} >
                <DisconnectOutlined style={{ color: '#f5222d' }} />
              </Button>
            </Popconfirm>
            <Button style={{ float: 'left', marginRight: '5px' }} onClick={() => {
              const str = querystring.stringify(Object.assign(qs, { eetype: 'orders' }));
              if (isSearchConditionEmpty(qs, dividersId)) {
                alert('请筛选条件');
                return false;
              }
              window.open(`${P}/api/tool/excel/export?${str}`)
            }} >批量导出</Button>
            <Popconfirm
              title="确定批量出单?"
              onConfirm={() => {
                const str = querystring.stringify(qs);
                if (isSearchConditionEmpty(qs, dividersId)) {
                  alert('请筛选条件');
                  return false;
                }
                window.open(`${P}/api/tool/orders/batch-shipment?${str}`)
              }}
              okText="是"
              cancelText="取消"
            >
              <Button style={{ float: 'left', marginRight: '5px' }} >批量出单</Button>
            </Popconfirm>
            <Link to={'/orders/action/'} target="_blank">
              <Button type="primary" style={{ float: 'right' }}><PlusOutlined />新建</Button>
            </Link>
            <BatchImportWrapper style={{ float: 'right', marginRight: '5px' }} />
          </div>
        }
        <div style={{ clear: 'both' }}></div>
        {
          loading ?
            ''
            :
            this.tableRender(data, loading, pagination)
        }
      </Spin>
    );
  }
}
